import React from 'react';
import {ProductUserMatrixProps} from "./RentalInterfaces";

const ProductUserMatrix: React.FC<ProductUserMatrixProps> = ({ data }) => {
  // @ts-ignore
  const productNames = [...new Set(data.map(item => item.product_name))].sort();
  // @ts-ignore
  const usernames = [...new Set(data.map(item => item.username))].sort();

  // Создаем объект для быстрого доступа к количеству по продукту и пользователю
  const quantityMap: Record<string, Record<string, number>> = {};
  data.forEach(item => {
    if (!quantityMap[item.product_name]) {
      quantityMap[item.product_name] = {};
    }
    quantityMap[item.product_name][item.username] = item.quantity;
  });

  console.log("quantityMap: ", quantityMap);

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
        <tr>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}></th>
          {usernames.map(username => (
            <th key={username} style={{ border: '1px solid #ddd', padding: '8px' }}>
              {username == 'admin' || username == 'vs' ? 'склад' : username}
            </th>
          ))}
        </tr>
        </thead>
        <tbody>
        {productNames.map(productName => (
          <tr key={productName}>
            <td style={{ border: '1px solid #ddd', padding: '8px', fontWeight: 'bold' }}>
              {productName}
            </td>
            {usernames.map(username => (
              <td key={`${productName}-${username}`} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                {quantityMap[productName]?.[username] ?? 0}
              </td>
            ))}
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductUserMatrix;